{
  "sticky_notes": "Notas Adhesivas"
}